export default __webpack_public_path__ + "static/media/studentProfiles.13c02d7d.jpg";